const Theme = {
  colors: {
    gray: "#bbb",
    darkGray: "rgb(68, 68, 68)",
    black: "#444",
    white: "#ffffff",
    offWhite: "#F4F4F4",
    green: "#449C44",
    lightGreen: "#70bf4a",
    lightGrey: "#707070",
    mullberry: "#870052",
    darkBlue: "#15407C",
    hoverBlue: "#006392",
    blue: "#0076AD",
    cgray: '#CCCCCC',
    dgray: '#999999'
  },
  breakpoints: {
    xs: "320",
    sm: "500",
    md: "960",
    lg: "1024",
    xl: "1440",
    xxl: "2560",
  },
};

export default Theme;
